import React from "react";
import { Coming } from "../../../components/Coming/Coming";

const Notification = () => {
  return (
    <div>
      <Coming />
    </div>
  );
};

export default Notification;
